import React from 'react'
import styled from 'styled-components'

const ButtonComponent = styled.button`
  color: ${(props) => props.color};
  background: ${(props) => props.backgroundColor};
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  margin-right: ${(props) => props.spacing};
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  &:hover {
    background: ${(props) => props.backgroundHover};
  }
`

export default ButtonComponent
